/**
 * Merges store-status-resolved locations into a context object's
 * ``sales_location`` field. If the context already has manual location
 * selections, only the intersection is kept. Otherwise the full
 * resolved list is used.
 *
 * Returns a shallow copy — the original context is not mutated.
 */
export function mergeStoreLocations<T extends Record<string, unknown>>(
  context: T,
  resolvedStoreLocations: string[]
): T {
  if (resolvedStoreLocations.length === 0) return context;

  const merged = { ...context } as T & { sales_location?: string[] };
  const manual = merged.sales_location ?? [];
  merged.sales_location =
    manual.length > 0
      ? manual.filter((loc) => resolvedStoreLocations.includes(loc))
      : resolvedStoreLocations;
  return merged as T;
}
